import { breakpoint } from '@carvana/ds-styles';
import Button from '@carvana/ds-button';

import { useTestFunc } from '@carvana/test-attributes';
import ValueTrackerLogo from './ValueTrackerLogo';
import {
  Background,
  Container,
  HeadLine,
  ImgWrapper,
  StyledImage,
  StyledLink,
  Text,
  TextContainer,
  LogoWrapper,
  RedirectLink
} from './Worth.styles';
import useAnalyticEvent from 'shared/hooks/useAnalyticEvent';
import { useMediaQuery } from 'shared/hooks/useMediaQuery';
import { buildNavigationUrl } from 'shared/routes';
import getAssetUrl from 'utilities/getAssetUrl';

const imageLoader = ({ src }: { src: string }) => getAssetUrl(`${src}.webp`);

const Worth = () => {
  const getTestAttributes = useTestFunc();
  const { recordEventAndNavigate } = useAnalyticEvent();
  const isMd = useMediaQuery(`(min-width: ${breakpoint.md})`);
  const isMobile = useMediaQuery(`(max-width: ${breakpoint.sm})`);
  const learnMoreUrl = buildNavigationUrl({ baseUrl: `/value-tracker` });
  const trackValueUrl = buildNavigationUrl({ baseUrl: `/value-tracker/get-value/vehicle` });

  const handleLearnMoreClick = (event: React.MouseEvent<HTMLElement>) =>
    recordEventAndNavigate(event, 'Landing Page', 'CVT - Learn more');

  const handleTrackValueClick = (event: React.MouseEvent<HTMLElement>) =>
    recordEventAndNavigate(event, 'Landing Page', 'CVT - Track my value');

  // Default to small/lg for SSR to match initial render
  const logoSize = isMd ? 'large' : 'small';

  return (
    <Background>
      <Container>
        <ImgWrapper>
          <StyledImage
            alt="Car with tracking lines"
            src="/images/value-tracker"
            priority
            quality={100}
            width={0}
            height={0}
            loader={imageLoader}
          />
          <StyledImage
            alt="Car with tracking lines"
            src="/images/value-tracker-mobile"
            priority
            quality={100}
            width={0}
            height={0}
            loader={imageLoader}
            className="mobile"
          />
        </ImgWrapper>
        <TextContainer>
          <LogoWrapper>
            <ValueTrackerLogo size={logoSize} />
          </LogoWrapper>
          <HeadLine>Stay up to speed with your car's value</HeadLine>
          <Text>
            Not ready to sell yet? Get updates so you always know your car's value.{' '}
            <StyledLink
              size="sm"
              href={learnMoreUrl}
              preventVisitedColor
              onClick={handleLearnMoreClick}
              {...getTestAttributes('LearnMore', 'ValueTracker-LearnMore')}
            >
              Learn More
            </StyledLink>
          </Text>
          {/* tablet button */}
          <RedirectLink href={trackValueUrl} className="tablet" onClick={handleTrackValueClick}>
            <Button
              size="sm"
              width={isMobile ? '100%' : '165px'}
              variant="secondary"
              {...getTestAttributes('TrackMyValue')}
            >
              Track My Value
            </Button>
          </RedirectLink>
        </TextContainer>
        {/* desktop button */}
        <RedirectLink href={trackValueUrl} onClick={handleTrackValueClick}>
          <Button size="lg" variant="secondary" {...getTestAttributes('TrackMyValue')}>
            Track My Value
          </Button>
        </RedirectLink>
      </Container>
    </Background>
  );
};

export default Worth;
